<template>
  <div>
    <q-form ref="editForm">
      <c-table
        ref="table"
        :columns="grid.columns"
        :data="grid.data"
        :editable="!disabled"
        :gridHeightAuto="true"
        :columnSetting="false"
        :filtering="false"
        :usePaging="false"
      >
        <!-- 버튼 영역 -->
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name==='customCol'">
            <!-- tableKey=" " -->
            <component
              :is="imprComponent"
              :col="col"
              :props="props"
              :inputEditable="editable&&!disabled"
              :isImmShow="true"
              :requestContentsCols="requestContentsCols"
              :tableKeys="tableKeys"
              ibmTaskTypeCd="ITT0000210"
              ibmTaskUnderTypeCd="ITTU000245"
              @imprChange="imprChange"
            >
            </component>
          </template>
        </template>
        <template slot="table-header-append">
          <c-field
            :disabled="disabled"
            :editable="editable"
            style="min-width: 150px;max-width: 250px;padding-bottom: 0px !important"
            name="checkUserId"
            placeholder="점검자 선택"
            v-model="checkUserId">
          </c-field>
          &nbsp;&nbsp;
          <c-select
            :disabled="disabled"
            :editable="editable"
            :comboItems="dateItems"
            type="custom"
            typetxt="일자선택"
            itemText="dayName"
            itemValue="dayCode"
            name="today"
            label=""
            v-model="today"
            @datachange="datechange"
          ></c-select>
        </template>
      </c-table>
    </q-form>
    <div class="popup-bottom-bar">
      <div class="popup-bottom-bar-btngroup">
        <q-btn-group outline >
          <c-btn
            :flat="true"
            v-if="editable && !disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="dailyCircuit.dccDailyCircuitCheckId ? { 
              checkResultList: dailyCircuit.checkResultList,
              checkUserModel: {
                dayId: this.columnKey,
                dccDailyCircuitCheckId: this.param.dccDailyCircuitCheckId, 
                checkUserId: this.checkUserId
              },
            } : this.dailyCircuit"
            :mappingType="mappingType"
            label="저장"
            icon="save"
            @beforeAction="saveData"
            @btnCallback="saveCallback" />
        </q-btn-group>
      </div>
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'safetyCheckDetail',
  props: {
    param: {
      type: Object,
      default: () => ({
        dccDailyCircuitCheckId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    },
    dailyCircuit: {
      type: Object,
      default: () => ({
        dccDailyCircuitCheckId: '',  // 열화점검 일련 번호
        plantCd: '',  // 사업장 코드
        checkStatusCd: '',  // 계획수립/점검중/점검완료
        checkDeptCd: '',  // 점검부서
        checkUserId: '',  // 점검자 ID
        checkDate: '',  // 점검월
        checkName: '',  // 점검명
        evaluationCompleteFlag: 'N',  // 결재완료 후 평가완료 처리
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        checkResultList: [], // sheet
        checkImproveList: [], // 개선 list
        checkUserList: [],
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: 'auto',
      },
      columnKey: '',
      checkUserId: '',
      dateItems: [],
      currentMonth: '',
      today: null,
      mappingType: 'POST',
      editable: true,
      detailUrl: '',
      saveUrl: '',
      isSave: false,
      isApproval: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return this.dailyCircuit.checkStatusCd === 'MCSC000015'
        || this.dailyCircuit.approvalStatusCd === 'ASC0000001'
    },
    // 테이블 키 멀티
    tableKeys() {
      return ['dccDailyCircuitCheckResultId','colkey'];
    },
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['checkItemName'];
    },
    // 개선요청 Component
    imprComponent() {
      return () => import(`${'@/pages/sop/mim/inspection/inpsectionTableImpr.vue'}`);
    },
  },
  watch: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.dcc.plan.get.url;
      this.saveUrl = transactionConfig.sop.dcc.result.newItem.url;
      // code setting
      this.currentMonth = this.$comm.getToday().slice(-5, this.$comm.getToday().length -3);
      // list setting
      this.today = '01'
      this.getDetail()
    },
    getDetail() {
      if (this.param.dccDailyCircuitCheckId) {
        this.$http.url = this.$format(this.detailUrl, this.param.dccDailyCircuitCheckId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.dailyCircuit, _result.data);
          
          if (this.dailyCircuit.checkDate.substring(5) === this.currentMonth) {
            this.today = this.$comm.getToday().slice(-2, this.$comm.getToday().length);
          }
          if (String(this.today.charAt(0)) === '0') {
            this.today = this.today.substring(1)
          }
          this.columnKey = 'day' + this.today;


          if (this.$_.findIndex(_result.data.checkUserList, {dayId: this.columnKey}) !== -1) {
            let idx = this.$_.findIndex(_result.data.checkUserList, {dayId: this.columnKey});
            this.checkUserId = _result.data.checkUserList[idx].checkUserId;
          } else {
            this.checkUserId = this.$store.getters.user.userId;
          }
          this.$_.forEach(this.dailyCircuit.checkResultList, _item => {
            _item.colkey = this.columnKey;
            this.grid.data.push(_item);
          })
          this.setColumns();
        },);
      } 
    },
    setColumns() {
      if (!this.dailyCircuit.checkDate) return;
      this.$comm.getComboItems('MIN_SAFETY_RESULT_CD').then(_result => {
        let _columns = [
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목',
            align: 'left',
            sortable: false,
          },
        ]
        let days = [];
        let year = this.dailyCircuit.checkDate.substring(0, 4);
        let month = this.dailyCircuit.checkDate.substring(5);

        let date = new Date(Number(year), Number(month), 0);

        for (let i=1; i<=date.getDate(); i++) {
          this.dateItems.push({
            dayName: i + '일',
            dayCode: String(i),
          })
        }
        days.push({
          name: this.columnKey,
          field: this.columnKey,
          label: this.today + '일',
          align: 'center',
          size: 'xs',
          setHeader: true,
          style: 'width:90px',
          comboItems: _result,
          type: 'select',
          sortable: false,
        })

        this.grid.columns = this.$_.concat(_columns, days, {
          name: 'customCol',
          field: 'customCol',
          label: '',
          align: 'center',
          type: 'custom',
          style: 'width:40px',
          sortable: false
        });
        this.grid.data = this.$_.clone(this.dailyCircuit.checkResultList)
            
        this.dailyCircuit.checkName = year + '년  ' + month + '월 일상 순회점검'
      })
    },
    saveData() {
      if (this.dailyCircuit.dccDailyCircuitCheckId) {
        this.saveUrl = transactionConfig.sop.dcc.result.newItem.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.dcc.plan.insert.url;
        this.mappingType = 'POST';
      }
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.dailyCircuit.regUserId = this.$store.getters.user.userId;
              this.dailyCircuit.chgUserId = this.$store.getters.user.userId;
              
              this.dailyCircuit.checkResultList = this.$_.clone(this.grid.data);

              if (this.mappingType === 'POST') {
                this.dailyCircuit.checkUserList.push({
                  dayId: this.columnKey,
                  dccDailyCircuitCheckId: this.param.dccDailyCircuitCheckId, 
                  checkUserId: this.checkUserId,
                  editFlag: 'C',
                })
              }

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.mappingType === 'POST') {
        this.dailyCircuit.dccDailyCircuitCheckId = result.data
        this.returnData.col1 = result.data
        this.$_.forEach(this.grid.data, _item => {
          _item.dccDailyCircuitCheckId = result.data;
          _item.editFlag = 'U';
        })
      }
      this.getDetail();
    },
    datechange() {
      this.columnKey = 'day' + this.today;
      if (this.$_.findIndex(this.dailyCircuit.checkUserList, {dayId: this.columnKey}) !== -1) {
        let idx = this.$_.findIndex(this.dailyCircuit.checkUserList, {dayId: this.columnKey});
        this.checkUserId = this.dailyCircuit.checkUserList[idx].checkUserId;
      } else {
        this.checkUserId = this.$store.getters.user.userId;
      }
      this.$_.forEach(this.dailyCircuit.checkResultList, _item => {
        _item.colkey = this.columnKey;
        this.grid.data.push(_item);
      })
      this.setColumns();
    },
    closePopUps() {
      this.$emit('closePopup')
    },
    // 개선창 닫기 후
    imprChange() {
      this.getDetail();
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
  }
};
</script>

<style lang="sass">
.customDate
  padding-bottom: 0px !important
  .q-field__before
    padding-top: 5px
.custom-text-before
  font-size:14px
  border: 1px solid rgba(0, 0, 0, 0.15) !important
  border-right: 0  !important
  border-radius: 4px 0 0 0
  line-height: 31px
  height: 33px !important
  min-height: 33px !important
.custom-field
  .q-field__native
    cursor: pointer
.q-field--dense .q-field__inner
  padding-bottom: 0px !important
  </style>